export default __webpack_public_path__ + "static/media/MSExcel_Example_1.703fd4f9.png";